import React from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import SavingsOverviewRowComponent from './SavingsOverviewRowComponent';
import SavingsOverviewRiskClassReductionRowComponent from './SavingsOverviewRiskClassMonthRowComponent';
import ShowComponent from '../../hocs/ShowComponent';

@ShowComponent
class SavingsOverviewComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ranges: [],
    };

    this.setRange = this.setRange.bind(this);
  }

  setRange(month) {
    const {
      loanpartsResult,
    } = this.props;

    const allRiskClassReductionMonths = loanpartsResult.loanParts[0].total.riskClassReduction
      .map(reduction => (
        reduction.month
      ));

    /* Check if there are riskClassReduction months defined */
    const hasLooptijdRente = allRiskClassReductionMonths.some(riskClassReductionMonth => riskClassReductionMonth > 1);

    /* Define lowerEnd and higherEnd as limits for the ranges */
    let lowerEnd;
    let higherEnd;

    if (hasLooptijdRente) {
      lowerEnd = allRiskClassReductionMonths.filter(reductionMonth => reductionMonth <= month).pop();
      higherEnd = allRiskClassReductionMonths.filter(reductionMonth => reductionMonth >= month)[0];

      /* If higher end is not defined, get the last date in mockData.loanParts[0].months */
      if (!lowerEnd) {
        lowerEnd = loanpartsResult.loanParts[0].months[0].month;
      }

      if (!higherEnd) {
        higherEnd = loanpartsResult.loanParts[0].months.pop().month;
      }

      if (month === 1) {
        higherEnd = allRiskClassReductionMonths[1];
      }
    } else {
      lowerEnd = loanpartsResult.loanParts[0].months[0].month;
      higherEnd = loanpartsResult.loanParts[0].months.pop().month;
    }

    let newRanges = this.state.ranges;
    const indexLowerEndInNewRanges = newRanges.findIndex(range => range.from === lowerEnd);
    if (indexLowerEndInNewRanges === -1) {
      newRanges.push({ from: lowerEnd, till: higherEnd });
    } else {
      newRanges = newRanges.filter((range, index) => index !== indexLowerEndInNewRanges);
    }

    this.setState({ ranges: newRanges });
  }

  render() {
    const {
      loanpartsResult,
    } = this.props;


    const allRiskClassReductionMonths = loanpartsResult.loanParts[0].total.riskClassReduction
      .map((reduction, index) => {
        let month;
        if (index !== 0) {
          month = reduction.month;
        }
        return month;
      });

    const rows = loanpartsResult.loanParts[0].months.map((loanpart, index) => {
      const riskClassReductionMonth = loanpartsResult.loanParts[0].total.riskClassReduction.find(month => (
        month.date === loanpart.date
      ));

      /* Show first month */
      const showFirstMonth = loanpart.month === 1;

      /* Always show row when its the first month after riskreduction */
      const dateAfterRiskClassReduction = allRiskClassReductionMonths.indexOf(loanpart.month - 1) > -1;

      const showWithinRange = this.state.ranges.some(range => (
        loanpart.month > range.from && loanpart.month < range.till && loanpart.month % 12 === 0
      ));

      /* Check */
      let rotatedWithinRangeArrow;
      if ((dateAfterRiskClassReduction || showFirstMonth)) {
        rotatedWithinRangeArrow = this.state.ranges.some(range => (
          loanpart.month >= range.from && loanpart.month <= range.till && loanpart.month
        ));
      }

      let component;
      const defaultComponent = (
        <SavingsOverviewRowComponent
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          month={loanpart.month}
          date={loanpart.date}
          remainingDebt={loanpart.remainingDebt}
          interest={loanpart.interest}
          gross={loanpart.gross}
          repayment={loanpart.repayment}
          monthlyPayment={loanpart.monthlyPayment}
          monthlyPaymentDiscount={loanpart.monthlyPaymentDiscount}
          showSetRangeButton={dateAfterRiskClassReduction || showFirstMonth}
          setRange={this.setRange}
          rotatedWithinRangeArrow={rotatedWithinRangeArrow}
        />
      );

      if (riskClassReductionMonth && !showFirstMonth) {
        component = (
          <SavingsOverviewRiskClassReductionRowComponent
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            date={riskClassReductionMonth.date}
            remainingDebt={riskClassReductionMonth.remainingDebt}
            interest={riskClassReductionMonth.interest}
            interestDiscount={riskClassReductionMonth.interestDiscount}
            gross={riskClassReductionMonth.gross}
            repayment={riskClassReductionMonth.repayment}
            monthlyPayment={riskClassReductionMonth.monthlyPayment}
            monthlyPaymentDiscount={riskClassReductionMonth.monthlyPaymentDiscount}
          />
        );
      } else if (showFirstMonth || showWithinRange || dateAfterRiskClassReduction
      ) {
        component = defaultComponent;
      }

      return component;
    });

    return (
      <table className="savings-container__table">
        <thead className="savings-container__table__dark-thead">
          <tr>
            <th colSpan={2}>Totaal overzicht</th>
            <th />
            <th />
            <th />
            <th />
            <th />
            <th />
          </tr>
        </thead>
        <thead className="savings-container__table__light-thead">
          <tr>
            <th>Jaar</th>
            <th>Schuldrest</th>
            <th>Rente</th>
            <th>Rente korting</th>
            <th>Rentelast</th>
            <th>Aflossing</th>
            <th>Maandlast</th>
            <th>Maandlast korting</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
        <tfoot>
          <tr>
            <td>Totaal</td>
            <td />
            <td />
            <td />
            <td>{numeral(loanpartsResult.total.total.interestPayment).format('$ 0,00')}</td>
            <td>{numeral(loanpartsResult.total.total.repayment).format('$ 0,00')}</td>
            <td>{numeral(loanpartsResult.total.total.gross).format('$ 0,00')}</td>
            <td />
          </tr>
        </tfoot>
      </table>
    );
  }
}

SavingsOverviewComponent.propTypes = {
  loanpartsResult: PropTypes.shape({}),
};

SavingsOverviewComponent.defaultProps = {
  loanpartsResult: {},
};

export default SavingsOverviewComponent;
